// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"a8cf7b61","107":"a8cf7b61","311":"a8cf7b61","367":"a8cf7b61","701":"a8cf7b61","916":"a8cf7b61"}[chunkId] + ".chunk.css";
};